// Map from cart contents to the richer model used for editing
// We may be restoring from an old kit that is no longer valid in the current catalog (for reordering old
// kits), so we only overwrite the default state with data we've validated against the catalog.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Plexity } from "../../KitDeserializer";
import { findOrganismByName } from "../KitToFormStateUtilityFunctions";
import { findProbePresetScale } from "../manual-pro/ManualProConsumerDetectForm";
import { AutomatedProKitPrice, SimpleCatalogVariantProbeSet, SimpleLibraryOrganismCustomTargetProbeSet } from "../rna-fish/KitModel";
import { extractNameBeforeParenthesis } from "../rna-fish/RnaFishKitToFormState";
import { defaultAutomatedProCatalogProbeSetState, defaultAutomatedProDetectPresetScale, defaultAutomatedProDetectState, defaultChromogenState, defaultMiscComponentFormState } from "./AdminEditKitForm";
import { getProbeAmps } from "./EditKitForm";
import { RnaCishEditableOrganism, RnaCishEditableTarget, } from "./ProbeSetForm";
import { Hapten, HcrAmplifier } from "./RnaCatalog";
export var NONE_ID = "NONE";
export var NONE_HCR_AMPLIFIER = new HcrAmplifier(NONE_ID);
export var NONE_HAPTEN = new Hapten(NONE_ID);
export var NONE_ENZYME = { id: NONE_ID, label: "NONE", chromogenCompatibility: NONE_ID };
export var NONE_CHROMOGEN = {
    id: NONE_ID,
    label: NONE_ID,
    platformCompatibility: [],
    enzymeCompatibility: "",
    bufferCompatibility: { id: NONE_ID, label: NONE_ID }
};
var NONE_CHROMOGEN_BUFFER = { id: NONE_ID, label: NONE_ID };
export var rnaCishKitToAdminFormState = function (catalog, kit, kitPrice) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var detectPresetScale = (_a = kit.detectComponent) === null || _a === void 0 ? void 0 : _a.presetScale;
    var defaultDetectPresetScale = detectPresetScale !== null && detectPresetScale !== void 0 ? detectPresetScale : defaultAutomatedProDetectPresetScale(catalog, kit.plexity, kit.platform);
    var detectComponentState = defaultAutomatedProDetectState(catalog.proAmplifier, kit.platform, kit.plexity, defaultDetectPresetScale);
    var detectEnabled = kit.detectComponent != null;
    if (kit.detectComponent) {
        detectComponentState = detectComponentToDetectFormState(kit.plexity, detectComponentState, kit.detectComponent, catalog, false, kitPrice);
    }
    var chromogenComponentState = defaultChromogenState();
    var chromogenEnabled = kit.chromogenComponent != null || kit.detectComponent != null;
    if (kit.chromogenComponent) {
        chromogenComponentState = chromogenKitToChromogenFormState(chromogenComponentState, kit.chromogenComponent, catalog, kitPrice);
    }
    var miscComponentState = defaultMiscComponentFormState();
    var miscComponentEnabled = false;
    if (kit.miscComponent) {
        miscComponentEnabled = true;
        miscComponentState = __assign(__assign({}, miscComponentState), { description: kit.miscComponent.description, scaleInMl: kit.miscComponent.scaleInMl.valueMl, scaleInMlText: kit.miscComponent.scaleInMl.valueWithUnit, scaleInSlides: kit.miscComponent.scaleInSlides, customPrice: {
                listPriceCents: (_b = kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.miscComponentPriceCents) !== null && _b !== void 0 ? _b : 0,
                effectivePriceCents: (_c = kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.miscComponentPriceCents) !== null && _c !== void 0 ? _c : 0
            } });
    }
    var probeSetState = [];
    var ampCatalog = getAmpCatalog(false, kit.plexity, catalog.proAmplifier.userConfigs);
    var probeAmps = getProbeAmps(ampCatalog, kit.platform);
    for (var i = 1; i <= kit.plexity; i++) {
        probeSetState = probeSetState.concat([
            {
                state: defaultAutomatedProCatalogProbeSetState(catalog, (_e = (_d = probeAmps[i - 1]) === null || _d === void 0 ? void 0 : _d.data) !== null && _e !== void 0 ? _e : catalog.proAmplifier.defaultHcrAmplifier, findProbePresetScale(catalog.presetScales, kit.platform.id, undefined, catalog.defaultAutomatedProScale, kit.plexity, i)),
                channel: i,
                metadata: findProbePresetScale(catalog.presetScales, kit.platform.id, undefined, catalog.defaultAutomatedProScale, kit.plexity, i)
            }
        ]);
    }
    if (kit.probeSetComponent.length > 0) {
        probeSetState = kit.probeSetComponent
            .slice()
            .sort(function (c1, c2) { return c1.channel - c2.channel; })
            .slice(0, kit.plexity === Plexity.TwoPlex ? 2 : 1)
            .map(function (probeSetComponent) {
            var probeState = adminProbeToProbeFormState(catalog, probeSetComponent, probeSetComponent.channel, kitPrice).probeSetState;
            return {
                state: __assign(__assign({}, probeState), { probeScalePmol: probeSetComponent.scale.pmol, probeScaleUl: probeSetComponent.scale.volume, probeHybridizationAScale: probeSetComponent.probeHybridizationAScale.volume, probeHybridizationBScale: probeSetComponent.probeHybridizationBScale.volume }),
                channel: probeSetComponent.channel,
                metadata: probeSetComponent.presetScale
            };
        });
    }
    var scale = (_v = (_t = (_q = (_o = (_k = (_h = (_g = (_f = kit.detectComponent) === null || _f === void 0 ? void 0 : _f.presetScale) === null || _g === void 0 ? void 0 : _g.units) !== null && _h !== void 0 ? _h : (_j = kit.detectComponent) === null || _j === void 0 ? void 0 : _j.customScale) !== null && _k !== void 0 ? _k : (_m = (_l = kit.probeSetComponent[0]) === null || _l === void 0 ? void 0 : _l.presetScale) === null || _m === void 0 ? void 0 : _m.units) !== null && _o !== void 0 ? _o : (_p = kit.probeSetComponent[0]) === null || _p === void 0 ? void 0 : _p.customScale) !== null && _q !== void 0 ? _q : (_s = (_r = kit.chromogenComponent) === null || _r === void 0 ? void 0 : _r.presetScale) === null || _s === void 0 ? void 0 : _s.units) !== null && _t !== void 0 ? _t : (_u = kit.chromogenComponent) === null || _u === void 0 ? void 0 : _u.customScale) !== null && _v !== void 0 ? _v : catalog.defaultAutomatedProScale;
    var customPriceEnabled = detectComponentState.customPrice !== undefined
        || chromogenComponentState.customPrice !== undefined
        || probeSetState.some(function (pss) { return pss.state.customPrice !== undefined; });
    return {
        chromogenEnabled: chromogenEnabled,
        chromogenState: chromogenComponentState,
        chromogenPresetScale: (_w = kit.chromogenComponent) === null || _w === void 0 ? void 0 : _w.presetScale,
        comment: kit.comment,
        config: kit.config,
        customPriceEnabled: customPriceEnabled,
        detectEnabled: detectEnabled,
        detectState: detectComponentState,
        detectPresetScale: detectPresetScale,
        errors: [],
        miscComponentEnabled: miscComponentEnabled,
        miscComponentState: miscComponentState,
        plexity: kit.plexity,
        priceLoading: false,
        probeSetEnabled: kit.probeSetComponent.length > 0,
        probeSetState: probeSetState,
        platform: kit.platform,
        reasonForOther: kit.reasonForOther.substring(0, kit.reasonForOther.indexOf("(")).trim(),
        reasonForOtherExplanation: (_x = extractStringFromParentheses(kit.reasonForOther)) !== null && _x !== void 0 ? _x : "",
        scale: scale
    };
};
var adminProbeToProbeFormState = function (catalog, probeSetComponent, channel, kitPrice) {
    var _a, _b;
    var probeSetState = defaultAutomatedProCatalogProbeSetState(catalog, catalog.proAmplifier.defaultHcrAmplifier);
    var probeSetAmplifier;
    var findOrganism = function (slo) {
        var orgById = catalog.probeSet.catalog.organisms.find(function (o) { return o.id === slo.id; });
        var orgByName = catalog.probeSet.catalog.organisms.find(function (o) { return o.name === slo.name; });
        return orgById ? orgById : orgByName;
    };
    var findPsf = function (org, family) {
        var psfById = org.probeSetFamilies.find(function (psf) { return psf.id === family.id; });
        var psfByName = org.probeSetFamilies.find(function (psf) { return psf.geneSymbol === family.geneSymbol; });
        return psfById ? psfById : psfByName;
    };
    var findVariant = function (psf, variant) {
        var variantById = psf.variants.find(function (v) { return v.id === variant.id; });
        var variantByName = psf.variants.find(function (v) { return v.name === variant.name; });
        return variantById ? variantById : variantByName;
    };
    var probeSet = probeSetComponent.probeSet;
    if (probeSet instanceof SimpleCatalogVariantProbeSet) {
        probeSetState = __assign(__assign({}, probeSetState), { probeLotNumber: kitPrice ? probeSet.probeLotNumber : undefined });
        var customerProvidedAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet.hcrAmplifier, catalog.proAmplifier);
        var customerProvidedOrganism = findOrganismByName(extractNameBeforeParenthesis(probeSet.customerOrganismName), catalog);
        if (customerProvidedOrganism != null) {
            var customerProvidedTarget = customerProvidedOrganism.probeSetFamilies.find(function (psf) {
                return psf.geneSymbol.trim().toLowerCase()
                    === extractNameBeforeParenthesis(probeSet.customerTargetName).trim().toLowerCase();
            });
            if (customerProvidedTarget != null) {
                var customerProvidedVariant = customerProvidedTarget.variants.find(function (v) {
                    var accession = v.accession ? v.accession.transcriptAccession : "";
                    return v.targetMrnaSeq === probeSet.customerSequence
                        && v.probeSetSize === probeSet.customerProbeSetSize
                        && accession.trim().toLowerCase()
                            === probeSet.customerAccessionNum.trim().toLowerCase();
                });
                if (customerProvidedVariant != null) {
                    probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(customerProvidedOrganism), target: RnaCishEditableTarget.fromLibTarget(customerProvidedVariant), targets: [
                            {
                                id: customerProvidedTarget.id,
                                geneSymbol: customerProvidedTarget.geneSymbol,
                                description: customerProvidedTarget.description,
                                synonyms: customerProvidedTarget.synonyms
                            }
                        ], hcrAmplifier: customerProvidedAmplifier });
                }
                else {
                    probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(customerProvidedOrganism), target: new RnaCishEditableTarget(customerProvidedTarget.geneSymbol, customerProvidedTarget.description, probeSet.customerAccessionNum, probeSet.customerSequence, probeSet.customerProbeSetSize, customerProvidedTarget.id, false, false, undefined), targets: [
                            {
                                id: customerProvidedTarget.id,
                                geneSymbol: customerProvidedTarget.geneSymbol,
                                description: customerProvidedTarget.description,
                                synonyms: customerProvidedTarget.synonyms
                            }
                        ], hcrAmplifier: customerProvidedAmplifier });
                }
            }
            else {
                probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(customerProvidedOrganism), target: new RnaCishEditableTarget(probeSet.customerTargetName, "", probeSet.customerAccessionNum, probeSet.customerSequence, probeSet.customerProbeSetSize, -1, false, false, undefined), hcrAmplifier: customerProvidedAmplifier });
            }
        }
        else {
            probeSetState = __assign(__assign({}, probeSetState), { organism: new RnaCishEditableOrganism(probeSet.customerOrganismName, "", -1), target: new RnaCishEditableTarget(probeSet.customerTargetName, "", probeSet.customerAccessionNum, probeSet.customerSequence, probeSet.customerProbeSetSize, -1, false, false, undefined), hcrAmplifier: customerProvidedAmplifier });
        }
        probeSetState = __assign({}, probeSetState);
        // If we cannot find the probeDesignOrganism by its id, i.e. a new batch was uploaded then we search by name, which
        // is unique for probeDesignOrganism per batch.
        var probeDesignOrganism = findOrganism(probeSet.organism);
        if (probeDesignOrganism !== undefined) {
            // same for probe set family
            var probeDesignTarget = findPsf(probeDesignOrganism, probeSet.probeSetFamily);
            if (probeDesignTarget !== undefined) {
                var probeDesignVariant = findVariant(probeDesignTarget, probeSet.variant);
                if (probeDesignVariant !== undefined) {
                    var hcrAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet.hcrAmplifier, catalog.proAmplifier);
                    probeSetState = __assign(__assign({}, probeSetState), { target: probeSetState.target.withProbeDesign(probeDesignVariant.id) });
                    probeSetAmplifier = hcrAmplifier;
                }
            }
        }
    }
    else if (probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet) {
        var hcrAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet.hcrAmplifier, catalog.proAmplifier);
        probeSetState = __assign(__assign({}, probeSetState), { organism: RnaCishEditableOrganism.fromLibOrg(findOrganism(probeSet.organism)), target: new RnaCishEditableTarget(probeSet.target.name, "", probeSet.target.accession, probeSet.target.targetMrnaSeq, probeSet.probeSetSize, -1, false, false, undefined), hcrAmplifier: hcrAmplifier, probeLotNumber: kitPrice ? probeSet.probeLotNumber : undefined });
        probeSetAmplifier = hcrAmplifier;
    }
    else {
        var hcrAmplifier = findRnaCishMatchingAmplifierOrDefault(probeSet.hcrAmplifier, catalog.proAmplifier);
        probeSetState = __assign(__assign({}, probeSetState), { organism: new RnaCishEditableOrganism(probeSet.organism.name, "", -1), target: new RnaCishEditableTarget(probeSet.target.name, "", probeSet.target.accession, probeSet.target.targetMrnaSeq, probeSet.probeSetSize, -1, false, false, undefined), hcrAmplifier: hcrAmplifier, probeLotNumber: kitPrice ? probeSet.probeLotNumber : undefined });
        probeSetAmplifier = hcrAmplifier;
    }
    if (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.customPrice) {
        var price = (_b = (_a = kitPrice.probeSetPriceCents.find(function (p) { return p.channel === channel; })) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : undefined;
        if (price) {
            probeSetState = __assign(__assign({}, probeSetState), { customPrice: {
                    listPriceCents: 0,
                    effectivePriceCents: price
                } });
        }
    }
    return {
        probeSetState: probeSetState,
        probeSetAmplifier: probeSetAmplifier
    };
};
var isDetectPriceCustom = function (kitPrice) {
    return kitPrice instanceof AutomatedProKitPrice ? kitPrice.customPrice : (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.detectPriceCustom) === true;
};
var isChromogenPriceCustom = function (kitPrice) {
    return kitPrice instanceof AutomatedProKitPrice ? kitPrice.customPrice : (kitPrice === null || kitPrice === void 0 ? void 0 : kitPrice.chromogenPriceCustom) === true;
};
export var detectComponentToDetectFormState = function (plexity, detectState, detectComponent, catalog, manualPro, kitPrice) {
    var ampCatalog = getAmpCatalog(manualPro, plexity, catalog.proAmplifier.userConfigs);
    var sortedChannels = detectComponent.channels.slice().sort(function (c1, c2) { return c1.channel - c2.channel; });
    var kitChannels = sortedChannels.map(function (ch) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var config = ampCatalog.proAmpConfigList.find(function (c) {
            var _a, _b, _c;
            return c.enzyme.id === ((_a = ch.enzyme) === null || _a === void 0 ? void 0 : _a.id) &&
                c.amplifier.id === ((_b = ch.hcrAmplifier) === null || _b === void 0 ? void 0 : _b.id) &&
                c.hapten.id === ((_c = ch.hapten) === null || _c === void 0 ? void 0 : _c.id) &&
                c.channelNum === ch.channel;
        });
        return {
            config: config,
            hcrAmplifier: (_a = config === null || config === void 0 ? void 0 : config.amplifier) !== null && _a !== void 0 ? _a : findRnaCishMatchingAmplifierOrNone(ch.hcrAmplifier, catalog.proAmplifier),
            hapten: (_b = config === null || config === void 0 ? void 0 : config.hapten) !== null && _b !== void 0 ? _b : findRnaCishMatchingHaptenOrNone(ch.hapten, catalog.proAmplifier),
            enzyme: (_c = config === null || config === void 0 ? void 0 : config.enzyme) !== null && _c !== void 0 ? _c : findRnaCishMatchingEnzymeOrNone(ch.enzyme, catalog.proAmplifier),
            editing: false,
            detectAntiHaptenUl: (_f = (_e = (_d = ch.detectAntiHapten) === null || _d === void 0 ? void 0 : _d.volume) === null || _e === void 0 ? void 0 : _e.valueUl) !== null && _f !== void 0 ? _f : 0,
            detectTyramideUl: (_j = (_h = (_g = ch.detectTyramide) === null || _g === void 0 ? void 0 : _g.volume) === null || _h === void 0 ? void 0 : _h.valueUl) !== null && _j !== void 0 ? _j : 0,
            detectEnzymeApUl: (_m = (_l = (_k = ch.detectEnzymeAp) === null || _k === void 0 ? void 0 : _k.volume) === null || _l === void 0 ? void 0 : _l.valueUl) !== null && _m !== void 0 ? _m : 0,
            detectEnzymeHrpUl: (_q = (_p = (_o = ch.detectEnzymeHrp) === null || _o === void 0 ? void 0 : _o.volume) === null || _p === void 0 ? void 0 : _p.valueUl) !== null && _q !== void 0 ? _q : 0,
            detectHrpQuencherUl: (_t = (_s = (_r = ch.detectHrpQuencher) === null || _r === void 0 ? void 0 : _r.volume) === null || _s === void 0 ? void 0 : _s.valueUl) !== null && _t !== void 0 ? _t : 0,
        };
    });
    var state = __assign(__assign({}, detectState), { channels: kitChannels, prefilled: detectComponent.prefilled, pretreatADewaxUl: detectComponent.pretreatADewax.volume.valueUl, pretreatBAntigenRetrievalUl: detectComponent.pretreatBAntigenRetrieval.volume.valueUl, pretreatBloxolUl: detectComponent.pretreatBloxol.volume.valueUl, detectAUl: detectComponent.detectA.volume.valueUl, detectBPmol: detectComponent.detectB.pmol, detectBConcentration: detectComponent.detectB.concentration, detectBUl: detectComponent.detectB.volume.valueUl, detectCUl: detectComponent.detectC.volume.valueUl, postProcessAUl: detectComponent.postProcessA.volume.valueUl, postProcessBUl: detectComponent.postProcessB.volume.valueUl, preHybridizationUl: detectComponent.preHybridizationScale.volume.valueUl, scalesExpanded: false });
    if (isDetectPriceCustom(kitPrice) && kitPrice != null) {
        state = __assign(__assign({}, state), { customPrice: {
                listPriceCents: kitPrice.detectPriceCents,
                effectivePriceCents: kitPrice.detectPriceCents
            } });
    }
    return state;
};
export var chromogenKitToChromogenFormState = function (chromogenState, chromogenComponent, catalog, kitPrice) {
    return __assign(__assign({}, chromogenState), { chromogen: findRnaCishMatchingChromogenOrNone(chromogenComponent.chromogen, catalog), chromogenBuffer: findRnaCishMatchingChromogenBufferOrNone(chromogenComponent.chromogenBuffer, catalog), chromogenBufferScaleUl: chromogenComponent.chromogenBufferScale.volume.valueUl, chromogenScaleUl: chromogenComponent.chromogenScale.volume.valueUl, hematoxylinScaleUl: chromogenComponent.hematoxylinScale.volume.valueUl, customPrice: isChromogenPriceCustom(kitPrice) && kitPrice != null ? {
            listPriceCents: kitPrice.chromogenPriceCents,
            effectivePriceCents: kitPrice.chromogenPriceCents
        } : undefined });
};
var findRnaCishMatchingAmplifierOrDefault = function (amp, catalog) {
    var found = catalog.hcrAmplifiers.find(function (a) { return a.id === (amp === null || amp === void 0 ? void 0 : amp.id); });
    if (found !== undefined) {
        return found;
    }
    return catalog.defaultHcrAmplifier;
};
var findRnaCishMatchingAmplifierOrNone = function (amp, catalog) {
    if (amp == null) {
        return NONE_HCR_AMPLIFIER;
    }
    return findRnaCishMatchingAmplifierOrDefault(amp, catalog);
};
var findRnaCishMatchingHaptenOrNone = function (hapten, catalog) {
    var _a;
    if (hapten == null) {
        return NONE_HAPTEN;
    }
    return (_a = catalog.hapten.find(function (h) { return h.id === hapten.id; })) !== null && _a !== void 0 ? _a : NONE_HAPTEN;
};
var findRnaCishMatchingEnzymeOrNone = function (enzyme, catalog) {
    var _a;
    if (enzyme == null) {
        return NONE_ENZYME;
    }
    return (_a = catalog.enzymes.find(function (e) { return e.id === enzyme.id; })) !== null && _a !== void 0 ? _a : NONE_ENZYME;
};
var findRnaCishMatchingChromogenOrNone = function (chromogen, catalog) {
    var _a;
    if (chromogen == null) {
        return NONE_CHROMOGEN;
    }
    return (_a = catalog.proChromogens.chromogens.find(function (c) { return c.id === chromogen.id; })) !== null && _a !== void 0 ? _a : NONE_CHROMOGEN;
};
var findRnaCishMatchingChromogenBufferOrNone = function (chromogenBuffer, catalog) {
    var _a;
    if (chromogenBuffer == null) {
        return NONE_CHROMOGEN_BUFFER;
    }
    return (_a = catalog.proChromogens.chromogenBuffers.find(function (c) { return c.id === chromogenBuffer.id; })) !== null && _a !== void 0 ? _a : NONE_CHROMOGEN_BUFFER;
};
export function getAmpCatalog(manualPro, plexity, catalog) {
    var ampCatalog;
    if (plexity === Plexity.TwoPlex) {
        ampCatalog = catalog.twoTargetProAmps;
    }
    else {
        if (manualPro) {
            ampCatalog = catalog.manualProAmps;
        }
        else {
            ampCatalog = catalog.oneTargetProAmps;
        }
    }
    return ampCatalog;
}
var extractStringFromParentheses = function (input) {
    var match = input.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
};
//# sourceMappingURL=RnaCishKitToAdminFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/RnaCishKitToAdminFormState.js
// module id = 77
// module chunks = 0